<mat-calendar
	(selectedChange)="onSelectedChange($event)"
	[selected]="selectedDateRange"
	[minDate]="offersDateRange?.start"
	[maxDate]="offersDateRange?.end"
>
</mat-calendar>
